export default "__VITE_ASSET__D5P$m2Z0__"